<template>
  <div class="rank" ref="container">
    <div class="top">
      <img class="" :src="base_url + '/uploads/routine/imgs/red_bg.png'" />
    </div>
    <div class="infos acea-row">
      <img class="avatar" :src="userInfo.avatar" />
      <div class="info">
        <div class="nickname line1">{{ userInfo.nickname }}</div>
        <div class="bottom acea-row">
          <div class="ranking acea-row">
            <img class="" src="@assets/images/rank_icon.png" />
            <span class="a">排名：{{ userInfo.identifier }}</span>
          </div>
          <div class="ranking acea-row">
            <img class="" src="@assets/images/butie_icon.png" />
            <span class="a">补贴： {{ userInfo.think_sum }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="title acea-row">
        <span class="a">排名</span>
        <span class="b">拼团达人</span>
        <span class="c">今日累计获得红包</span>
      </div>
      <div class="item acea-row" v-for="(item, index) in userList" :key="index">
        <div class="a">
          <img
            v-if="item.identifier == 1"
            class=""
            src="@assets/images/medal01.png"
          />
          <img
            v-if="item.identifier == 2"
            class=""
            src="@assets/images/medal02.png"
          />
          <img
            v-if="item.identifier == 3"
            class=""
            src="@assets/images/medal03.png"
          />
          <span v-if="item.identifier > 3">{{ item.identifier }}</span>
        </div>
        <div class="b acea-row">
          <img class="" :src="item.user.avatar" />
          <span class="nickname line1">{{ item.user.nickname }}</span>
        </div>
        <div class="c money">￥{{ item.think_sum }}</div>
      </div>
    </div>
    <img class="pinktitle" src="@assets/images/pinktitle.png" />
    <div class="pinklist">
      <div
        class="item acea-row row-between-wrapper"
        v-for="(item, index) in goodsList"
        :key="index"
      >
        <div class="top1 acea-row row-between-wrapper">
          <img class="goods_img" :src="item.image" />
          <div class="infos1">
            <div class="store_name line1">{{ item.store_name }}</div>
            <div class="progress">
              <div
                class="sel"
                :style="{
                  width: (item.pt_info.num / item.pt_info.ptnum) * 100 + '%'
                }"
              ></div>
              <span class="a">
                {{ (item.pt_info.num / item.pt_info.ptnum) * 100 }}%
              </span>
            </div>
            <div class="num acea-row row-between-wrapper">
              <div class="imgs acea-row" style="">
                <img
                  v-for="(i, ind) in item.pt_info.user"
                  :key="ind"
                  :style="{ left: 4.27 * ind + 'vw' }"
                  class=""
                  :src="i.avatar"
                />
              </div>
              <div class="a">{{ item.pt_info.num }}人已拼团</div>
            </div>
            <div class="price acea-row">
              <div class="price_1">
                ￥<span class="a">{{ item.price }}</span>
              </div>
              <div class="ot_price">￥{{ item.ot_price }}</div>
            </div>
          </div>
        </div>
        <div
          class="bottom acea-row row-between-wrapper"
          :style="{
            backgroundImage:
              'url(' + base_url + '/uploads/routine/imgs/pinklist_bg.png)'
          }"
        >
          <div class="left acea-row">
            <img class="red_icon" src="@assets/images/red_icon.png" />
            <div class="bottom_info acea-row">
              <div class="top2">
                <span class="a">{{ item.pt_info.ptnum }}</span>
                人拼团
                <span class="a">{{ item.pt_info.zjnum }}</span>
                人拼中
              </div>
              <div class="bottom1">
                未拼中立得:<span class="a">￥</span
                ><span class="b">{{ item.pt_info.ctj }}</span>
              </div>
            </div>
          </div>
          <div class="right">立即拼团</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getGroomList, brokerageRanking } from "@api/store";
import { VUE_APP_IMG_URL } from "@utils";
export default {
  name: "rank",
  data() {
    return {
      base_url: VUE_APP_IMG_URL,
      userInfo: {},
      loading: false,
      loadend: false,
      goodsList: [],
      page: 1,
      limit: 10,
      userList: []
    };
  },
  mounted() {
    this.getrank();
    this.gethotpinklist();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.gethotpinklist();
    });
  },
  methods: {
    // 获取红包排行榜
    getrank() {
      brokerageRanking()
        .then(res => {
          console.log(res);
          this.userList = res.data.list;
          this.userInfo = res.data.user;
        })
        .catch(res => {
          console.log(res);
        });
    },
    // 获取热门拼团列表
    gethotpinklist() {
      var that = this;
      if (that.loadend) return;
      if (that.loading) return;
      this.loading = true;
      let data = {
        page: this.page,
        limit: this.limit
      };
      getGroomList(2, data)
        .then(res => {
          var list = res.data.list || [];
          that.loadend = list.length < that.limit;
          that.loading = false;
          that.page = that.page + 1;
          that.goodsList = that.goodsList.concat(list);
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.rank {
  .top {
    width: 100%;
    height: 40vw;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .infos {
    width: 94.67vw;
    height: 26.67vw;
    align-items: center;
    border-radius: 2vw;
    background-color: #ffffff;
    padding: 5.33vw 4vw;
    margin: 2.67vw;
    .avatar {
      width: 16vw;
      height: 16vw;
      border-radius: 50%;
      margin-right: 5.2vw;
    }
    .info {
      .nickname {
        font-size: 4vw;
        max-width: 60vw;
        padding-bottom: 2vw;
      }
      .bottom {
        flex-wrap: nowrap;
        div {
          align-items: center;
          margin-right: 6.4vw;
          span {
            font-size: 3.47vw;
          }
          img {
            margin-right: 2.67vw;
            width: 4.8vw;
            height: 4.8vw;
          }
        }
      }
    }
  }
  .list {
    width: 94.67vw;
    background-color: #ffffff;
    border-radius: 2vw;
    margin: 0 2.67vw;
    padding: 0 2.8vw;
    .title,
    .item {
      height: 14.4vw;
      align-items: center;
      font-size: 3.47vw;
      color: #333333;
      flex-wrap: nowrap;
      .a {
        width: 12vw;
        text-align: center;
        img {
          width: 8vw;
          height: 8vw;
        }
      }
      .b {
        width: 58vw;
        align-items: center;
        img {
          width: 9.87vw;
          height: 9.87vw;
          border-radius: 50%;
          margin-right: 2.8vw;
        }
        .nickname {
          max-width: 35vw;
        }
      }
      .c {
        width: 32vw;
        font-size: 3.47vw;
        text-align: right;
        &.money {
          color: #ff4142;
        }
      }
    }
  }
  .pinktitle {
    width: 32vw;
    height: 6.67vw;
    margin: 5.33vw 34vw;
  }
  .pinklist {
    width: 100%;
    padding: 0 2.67vw;
    z-index: 1;
    position: relative;
    .item {
      width: 100%;
      background-color: #ffffff;
      border-radius: 3vw;
      height: 50.67vw;
      margin-bottom: 2.67vw;
      padding: 2.67vw;
      flex-direction: column;
      .top1 {
        width: 100%;
        .goods_img {
          width: 29.33vw;
          height: 29.33vw;
          border-radius: 1vw;
        }
        .infos1 {
          width: 57vw;
          .store_name {
            font-size: 3.47vw;
            color: #333333;
            font-weight: 600;
          }
          .progress {
            width: 100%;
            height: 2.67vw;
            background-color: rgba(255, 67, 64, 0.3);
            border-radius: 1vw;
            position: relative;
            margin: 4vw 0 2.8vw;
            .sel {
              height: 100%;
              border-radius: 1vw;
              background-color: #ff4a2d;
            }
            .a {
              color: #fff;
              width: 100%;
              position: absolute;
              text-align: center;
              top: 0;
              left: 0;
              font-size: 2.93vw;
              line-height: 2.67vw;
            }
          }
          .num {
            .imgs {
              position: relative;
              height: 5.07vw;
              img {
                position: absolute;
                width: 5.07vw;
                height: 5.07vw;
                border-radius: 50%;
              }
            }
            .a {
              color: #333333;
              font-size: 3.2vw;
            }
          }
          .price {
            align-items: center;
            margin-top: 3vw;
            .price_1 {
              font-size: 3.47vw;
              color: #333333;
              font-weight: 600;
              .a {
                font-size: 4.8vw;
              }
            }
            .ot_price {
              color: #999999;
              font-size: 3.47vw;
            }
          }
        }
      }
      .bottom {
        width: 100%;
        height: 13.33vw;
        background-size: 100% 100%;
        padding: 0 6.93vw 0 3.47vw;
        .left {
          height: 100%;
          align-items: center;
          .red_icon {
            width: 7.2vw;
            height: 7.2vw;
            margin-right: 2vw;
          }
          .bottom_info {
            flex-direction: column;
            // align-items: center;
            .top2 {
              font-size: 2.93vw;
              color: #333333;
              .a {
                color: #ff4142;
              }
            }
            .bottom1 {
              line-height: 4vw;
              font-size: 3.2vw;
              color: #333333;
              .a {
                color: #ff4142;
                font-size: 3.47vw;
                font-weight: 600;
              }
              .b {
                font-weight: 600;
                font-size: 4.8vw;
                color: #ff4142;
              }
            }
          }
        }
        .right {
          color: #fff;
          font-size: 4vw;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
